module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-Book-43a9d2fc7a111f0519c27372b16e26f5.woff";